import LinkChip from '../LinkChip/LinkChip';
import styles from './LinkStatusContainer.module.scss';

interface LinkStatusContainerProps {
  linked: boolean;
  top?: number;
}

const LinkStatusContainer: React.FC<React.PropsWithChildren<LinkStatusContainerProps>> = ({
  children,
  linked,
  top,
}) => (
  <div className={styles['card-edit-input-container']}>
    {children}
    {linked && (
      <div className={styles['link-chip-container']} style={{ top }}>
        <LinkChip />
      </div>
    )}
  </div>
);

export default LinkStatusContainer;
